import React from 'react';
import * as S from './BoardingDropingPointDetails.styles';

type LocPointProps = {
  cardHdr?: string;
  dateTime?: string;
  locationPoint?: string;
  cardContent?: string;
};

const BoardingDropingPointDetails = ({
  cardHdr,
  dateTime,
  locationPoint,
  cardContent,
}: LocPointProps) => (
  <S.BoardingPointWrap>
    <S.CardHdr>{cardHdr}</S.CardHdr>
    <S.DateTag>{dateTime}</S.DateTag>
    <S.LocationPoint>{locationPoint}</S.LocationPoint>
    <S.CardContent>{cardContent}</S.CardContent>
   {false ? <S.CardLink>View on Map</S.CardLink> :null}
  </S.BoardingPointWrap>
);

export default BoardingDropingPointDetails;
